export const TipificationKeys = {
  ADVICE_DIGITAL_PAYMENT: 'ADVICE_DIGITAL_PAYMENT',
  ADVICE_MODIFICATION_PAYMENT_METHOD: 'ADVICE_MODIFICATION_PAYMENT_METHOD',
  ADVICE_PAYMENT_STATUS: 'ADVICE_PAYMENT_STATUS',
  ADVICE_PENDING_PAYMENT_QUERY: 'ADVICE_PENDING_PAYMENT_QUERY',
  ASSISTANCE_BATTERY_PROBLEM: 'ASSISTANCE_BATTERY_PROBLEM',
  ASSISTANCE_CANCEL_CRANE: 'ASSISTANCE_CANCEL_CRANE',
  ASSISTANCE_LACK_FUEL: 'ASSISTANCE_LACK_FUEL',
  ASSISTANCE_NEED_CRANE: 'ASSISTANCE_NEED_CRANE',
  ASSISTANCE_NEED_REMIS: 'ASSISTANCE_NEED_REMIS',
  ASSISTANCE_TIRE_PUNCTURED: 'ASSISTANCE_TIRE_PUNCTURED',
  DOCUMENTATION_SEND_CIRCULATION_CARD: 'DOCUMENTATION_SEND_CIRCULATION_CARD',
  DOCUMENTATION_SEND_CERTIFICATE_COVERAGE:
    'DOCUMENTATION_SEND_CERTIFICATE_COVERAGE',
  DOCUMENTATION_SEND_CERTIFICATE_PAYMENT_UP_DATE:
    'DOCUMENTATION_SEND_CERTIFICATE_PAYMENT_UP_DATE',
  DOCUMENTATION_SEND_INVOICE: 'DOCUMENTATION_SEND_INVOICE',
  DOCUMENTATION_SEND_MERCOSUR_CERTIFICATE:
    'DOCUMENTATION_SEND_MERCOSUR_CERTIFICATE',
  DOCUMENTATION_SEND_PAYMENT_COUPON: 'DOCUMENTATION_SEND_PAYMENT_COUPON',
  DOCUMENTATION_SEND_POLICY: 'DOCUMENTATION_SEND_POLICY',
  ENDORSEMENT_CHASIS: 'ENDORSEMENT_CHASIS',
  ENDORSEMENT_DOWNGRADE: 'ENDORSEMENT_DOWNGRADE',
  ENDORSEMENT_MOTOR: 'ENDORSEMENT_MOTOR',
  ENDORSEMENT_PATENT: 'ENDORSEMENT_PATENT',
  ENDORSEMENT_UPGRADE: 'ENDORSEMENT_UPGRADE',
  POLICY_CANCEL_ONLINE_CONFIRMED: 'POLICY_CANCEL_ONLINE_CONFIRMED',
  POLICY_CANCEL_ONLINE_REQUEST: 'POLICY_CANCEL_ONLINE_REQUEST',
  USER_ENDORSMENT_CHANGE_MAIL: 'USER_ENDORSMENT_CHANGE_MAIL',
  USER_ENDORSMENT_CHANGE_PASSWORD: 'USER_ENDORSMENT_CHANGE_PASSWORD',
  USER_ENDORSMENT_CHANGE_PHONE: 'USER_ENDORSMENT_CHANGE_PHONE',
  USER_ENDORSMENT_CHANGE_PHONE_ADDITIONAL:
    'USER_ENDORSMENT_CHANGE_PHONE_ADDITIONAL',
  ADD_CLAIM: 'ADD_CLAIM',
  STATUS_VEHICLE_INSPECTION_ANALYSIS: 'STATUS_VEHICLE_INSPECTION_ANALYSIS',
} as const;
